module.exports = __webpack_public_path__ + "assets/images/app-switcher-active.bd9896f0ef192141f645423bba1abb09.svg";